import { WebPlugin } from '@capacitor/core';
import type { StorageMigrationPlugin, LegacyStorageResult } from './definitions';

export class StorageMigrationWeb extends WebPlugin implements StorageMigrationPlugin {
  async getLegacyLocalStorage(): Promise<LegacyStorageResult> {
    // Sur le web, on ne peut pas accéder aux données d'une autre origine
    // Cette implémentation est juste un stub pour la compatibilité
    console.warn('StorageMigration: Non supporté sur le web');
    return {
      success: false,
      error: 'Not supported on web platform',
    };
  }
}
